import { AnimatePresence, type Variants, motion } from "framer-motion"
import type React from "react"
import styled from "styled-components"
import { Icon, type IconProps } from "../Icon"
import type { BorderProps } from "../types/props"
import { getBorderStyle } from "../util/props/border"

interface WrapperProps extends BorderProps {
  width: string
  maxWidth: string
  padding: string
  fontSize: string
  color: string
  background: string
  borderRadius?: string
}
const Wrapper = styled(motion.div)<WrapperProps>`
  position: relative;
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  padding: ${(props) => props.padding};

  display: grid;
  grid-template-columns: auto auto;

  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  background: ${(props) => props.background};

  ${getBorderStyle}
  border-radius: ${(props) => props.borderRadius};
  background-clip: padding-box;

  i {
    grid-column: 1;
    align-self: center;
  }
  span {
    grid-column: 2;
  }
`

const VARIANTS: Variants = {
  visible: {
    opacity: 1,
    y: 0,
  },
  hidden: {
    opacity: 0,
    y: 20,
  },
}

export interface MessageProps extends BorderProps {
  show: boolean
  text: string | React.ReactNode

  iconProps?: Partial<IconProps>
  noAnimation?: boolean
  noIcon?: boolean

  width?: string
  maxWidth?: string
  padding?: string
  fontSize?: string
  color?: string
  background?: string
  borderRadius?: string

  onAnimationRest?: (show: boolean) => void
  onClick?: (event: React.MouseEvent) => void
}

export const Message: React.FC<MessageProps> = ({
  show,
  text,

  iconProps = {},
  noAnimation = false,
  noIcon = false,

  width = "auto",
  maxWidth = "none",
  padding = "0",
  fontSize = "1em",
  color = "inherit",
  background = "inherit",

  border,
  borderWidth,
  borderStyle,
  borderColor,
  borderRadius,

  onAnimationRest = () => void 0,
  onClick = () => void 0,
}) => {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <Wrapper
          variants={VARIANTS}
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={noAnimation ? { duration: 0 } : undefined}
          width={width}
          maxWidth={maxWidth}
          padding={padding}
          fontSize={fontSize}
          color={color}
          background={background}
          border={border}
          borderWidth={borderWidth}
          borderStyle={borderStyle}
          borderColor={borderColor}
          borderRadius={borderRadius}
          onAnimationComplete={() => onAnimationRest(show)}
          onClick={onClick}
        >
          {!noIcon && (
            <Icon
              icon="info-circle"
              type="solid"
              color="info"
              margin="0 6px 0 0"
              translateY="1px"
              {...iconProps}
            />
          )}
          <span>{text}</span>
        </Wrapper>
      )}
    </AnimatePresence>
  )
}
